"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderIcon = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const is_element_1 = __importDefault(require("../components/utils/is-element"));
function renderIcon(icon, className, props) {
    if (!icon) {
        return null;
    }
    else if ((0, is_element_1.default)(icon)) {
        return react_1.default.cloneElement(icon, {
            className: (0, classnames_1.default)(icon.props.className, className),
            ...props,
        });
    }
    else {
        return react_1.default.createElement(icon, { className, ...props });
    }
}
exports.renderIcon = renderIcon;
exports.default = renderIcon;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVuZGVyLWljb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9pY29ucy9yZW5kZXItaWNvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxrREFBMEI7QUFDMUIsNERBQW9DO0FBRXBDLGdGQUF1RDtBQUt2RCxTQUFnQixVQUFVLENBQUMsSUFBMEIsRUFBRSxTQUFrQixFQUFFLEtBQTBCO0lBQ25HLElBQUksQ0FBQyxJQUFJLEVBQUU7UUFDVCxPQUFPLElBQUksQ0FBQztLQUNiO1NBQU0sSUFBSSxJQUFBLG9CQUFTLEVBQUMsSUFBSSxDQUFDLEVBQUU7UUFDMUIsT0FBTyxlQUFLLENBQUMsWUFBWSxDQUFDLElBQUksRUFBRTtZQUM5QixTQUFTLEVBQUUsSUFBQSxvQkFBVSxFQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsU0FBUyxFQUFFLFNBQVMsQ0FBQztZQUN0RCxHQUFHLEtBQUs7U0FDVCxDQUFDLENBQUM7S0FDSjtTQUFNO1FBQ0wsT0FBTyxlQUFLLENBQUMsYUFBYSxDQUFDLElBQUksRUFBRSxFQUFFLFNBQVMsRUFBRSxHQUFHLEtBQUssRUFBRSxDQUFDLENBQUM7S0FDM0Q7QUFDSCxDQUFDO0FBWEQsZ0NBV0M7QUFFRCxrQkFBZSxVQUFVLENBQUMifQ==